<template>
    <Layout>
        <section class="section" style="min-height: 500px">
            <div class="container">
                <div class="no-free-will">
                    <div class="row">
                        <div class="col-md-12">
                            <h2>Registration Update Completed</h2>
                            <p>
                                You have successfully updated your application.
                                You will receive an email shortly acknowledging
                                your <span style="color: red">updates</span> .
                                We look forward to welcoming you to the
                                conference.
                            </p>
                            <router-link to="/" class="btn btn-sm"
                                >Click here to view your dashboard</router-link
                            >
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </Layout>
</template>

<script>
import Layout from "@/components/layouts/Layout.vue";

export default {
    name: "ThankAfterRegistration",
    components: { Layout },
};
</script>
